import React from "react";

import Skeleton from "@busbud/design-system-components/dist/Skeleton";
import Stack from "@busbud/design-system-components/dist/Stack";

import { useStyles } from "./seat-selection-bottom-section-skeleton.styles";

export const SeatSelectionBottomSectionSkeleton: React.FC = () => {
  const { classes } = useStyles();

  return (
    <Stack className={classes.root} direction="column" spacing={2}>
      <Stack justifyContent="space-between" alignItems="center">
        <Stack direction="column" spacing={0.5}>
          <Skeleton size="md" width={8} />
          <Skeleton size="sm" width={12} />
        </Stack>
        <Skeleton size="md" width={10} />
      </Stack>
      <Skeleton size="xl" width={32} />
    </Stack>
  );
};
